import apiClient from '../api';
import {executeAndWaitResponse} from './service';

export const find = async (payload) =>
  executeAndWaitResponse(() => apiClient.renewals.find(payload));

export default {
  find,
};
